import { defineStore } from "pinia";
import { computed, ref } from "vue";
import { useAuth } from "./auth";
import { Invoices } from "@busy-human/k9-library";
import { query, where } from "firebase/firestore";
import { DataInstance } from "@busy-human/gearbox";
import { Userspaces } from '@busy-human/k9-library';

export const useInvoices = defineStore('invoices', () => {
    const invoices = ref(new Map<string, DataInstance<Invoices.Model>>());
    const loading = ref(false);

    async function fetchUserInvoices(uid: string) {
        console.log("Calling fetchUserInvoices", uid);
        const auth = useAuth();
        invoices.value.clear();
        loading.value = true;
        const docs = await Invoices.Collection.subset(ref => query(ref, where('userId', '==', uid!))).fetch();
        for(const doc of docs) {
            invoices.value.set(doc.$id, doc.data());
        }
        loading.value = false;
    }

    async function fetchAllInvoices() {
        console.log("Calling fetchAllInvoices");
        const auth = useAuth();
        invoices.value.clear();
        loading.value = true;
        const docs = await Invoices.Collection.fetchAll();
        for(const doc of docs.items) {
            invoices.value.set(doc.$id, doc.data());
        }
        loading.value = false;
    }

    const asArray = computed(() => {
        const arr: DataInstance<Invoices.Model>[] = [];
        for(const [uid, req] of invoices.value) {
            arr.push(req);
        }
        return arr;
    })

    const active = computed(() => asArray.value.filter(r => {
        if(r.initialPaymentPaid && !r.finalPaymentRequired) return false;
        return r.paidAmount < r.totalAmount;
    }));

    function openInvoicePayment(invoiceId: string) {
        loading.value = true;
        const url = new URL(`https://us-central1-${CONFIG.firebase.config.projectId}.cloudfunctions.net/stripeCheckout`);
        url.searchParams.set("invoiceId", invoiceId);
        url.searchParams.set("baseurl", window.location.origin);
        console.log("THIS IS LOADING", loading.value);

        // Byebye!
        window.location.href = url.toString();
    }

    return { invoices, loading, fetchUserInvoices, asArray, active, openInvoicePayment, fetchAllInvoices };
});